import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Card } from "@redotech/redo-web/card";
import * as gridCss from "@redotech/redo-web/grid.module.css";
import { FormTextInput } from "@redotech/redo-web/text-input";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import classNames from "classnames";
import { memo } from "react";

export const customerAccountsGeneralForm = groupInput({
  enabled: input<boolean>(),
  multipassSecret: input<string>(),
  webPixelEnabled: input<boolean>(),
});

export type CustomerAccountsGeneralForm = InputSchema.Input<
  typeof customerAccountsGeneralForm
>;

export type CustomerAccountsGeneralValue = InputSchema.Value<
  typeof customerAccountsGeneralForm
>;

export const customerAccountsGeneralDefault: CustomerAccountsGeneralValue = {
  enabled: true,
  multipassSecret: "",
  webPixelEnabled: false,
};

export const CustomerAccountsGeneralCard = memo(
  function CustomerAccountsGeneralCard({
    input,
  }: {
    input: CustomerAccountsGeneralForm;
  }) {
    const { enabled, multipassSecret, webPixelEnabled } = input.inputs;

    return (
      <Card title="Customer accounts">
        <section className={gridCss.grid}>
          <div className={gridCss.span12}>
            <div className={gridCss.grid}>
              <div className={classNames(gridCss.span6L, gridCss.span12)}>
                <RedoToggle
                  description="Enable Customer Accounts product"
                  label="Enabled"
                  setValue={enabled.setValue}
                  size="sm"
                  value={enabled.value}
                />
              </div>
            </div>
          </div>
          <div className={gridCss.span12}>
            <div className={gridCss.grid}>
              <div className={classNames(gridCss.span6L, gridCss.span12)}>
                <FormTextInput
                  description="If the merchant is on Shopify Plus, enter the multipass secret here. It can be found in their Shopify Admin under Settings > Customer accounts > Multipass."
                  input={multipassSecret}
                  label="Multipass secret"
                />
              </div>
            </div>
          </div>
          <div className={gridCss.span12}>
            <div className={gridCss.grid}>
              <div className={classNames(gridCss.span6L, gridCss.span12)}>
                <RedoToggle
                  description="Activate the web pixel to track customer shopping activity"
                  label="Web pixel enabled"
                  setValue={webPixelEnabled.setValue}
                  size="sm"
                  value={webPixelEnabled.value}
                />
              </div>
            </div>
          </div>
        </section>
      </Card>
    );
  },
);
